import React from 'react'
import PropTypes from 'prop-types'

import { Video } from '@aok/video'

import defaultProps from '../../../utils/propTypes/defaultProps'

import MacroContainer from '../../_layout/Macro/MacroContainer'
import VideoPrivacyOverlay from '../../molecules/VideoPrivacyOverlay/VideoPrivacyOverlay'

const M035 = ({ video }) => {
  const renderVideo = () => (
    <Video
      className={`
      ${video.playerType === 'kaltura' ? (video.playlistId ? 'h-600' : 'h-450') : ''}
      ${video.playerType !== 'kaltura' ? 'relative h-0 pb-16/9' : ''}
    `}
      {...video}
      staticLabels={{
        privacyButtonTitle: 'Video laden',
        playButtonTitle: 'Video abspielen',
        errorMessage: 'Es ist ein Fehler aufgetreten. Das Video konnte nicht geladen werden.',
      }}
      lang="de"
      autoplay={false}
      VideoPreview={<VideoPrivacyOverlay playerType={video.playerType} />}
    >
      {video.caption && (
        <figcaption className="font-light text-14 leading-20 text-6d767c mt-16 600:mx-92 840:mx-0">
          {video.caption}
        </figcaption>
      )}
    </Video>
  )

  return <MacroContainer dataTrackingName="M035">{renderVideo()}</MacroContainer>
}

M035.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    uploadDate: PropTypes.string,
    caption: PropTypes.string,
    videoId: PropTypes.string,
    playlistId: PropTypes.string,
    playlistName: PropTypes.string,
    playerType: PropTypes.oneOf(['youtube', 'vimeo', 'kaltura']),
    previewImage: PropTypes.shape({
      variants: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          breakpoint: PropTypes.number,
        })
      ),
    }),
  }),
}

M035.defaultProps = {
  video: {
    id: 'abc',
    playerType: 'youtube',
    name: defaultProps.NAME,
    description: defaultProps.DESCRIPTION,
    uploadDate: defaultProps.DATE,
  },
}

export default M035
